import React, { type ComponentType, useEffect } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import { useExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { RIGHT_SIDE_PANEL_EXPERIENCE } from './constants.tsx';

const LazyRightSidePanel = lazyForPaint<ComponentType<{}>>(
	() => import(/* webpackChunkName: "async-jira-home-right-side-panel" */ './index'),
);

export const AsyncRightPanel = (): React.JSX.Element => {
	const startExperience = useExperienceStart(RIGHT_SIDE_PANEL_EXPERIENCE);
	const onFail = useExperienceFail(RIGHT_SIDE_PANEL_EXPERIENCE);

	useEffect(() => {
		startExperience();
	}, [startExperience]);

	return (
		<JSErrorBoundary
			id="right-side-panel"
			packageName="jira-home-right-side-panel"
			fallback="unmount"
			onError={onFail}
		>
			<Placeholder name="async-jira-home-right-side-panel" fallback={null}>
				<LazyRightSidePanel />
			</Placeholder>
		</JSErrorBoundary>
	);
};
